import { render, staticRenderFns } from "./NoContent.vue?vue&type=template&id=6f06a4e6&scoped=true"
var script = {}
import style0 from "./NoContent.vue?vue&type=style&index=0&id=6f06a4e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f06a4e6",
  null
  
)

export default component.exports